import $ from 'jquery'
import stage from './stage'
import render from './render'

class Navigation {

  constructor() {

  }


  init() {
    this.body = $('body')
    this.menu = $('[data-section]')
    this.sections = $('[data-to]')
    this.nav = $('.navigation')

    this.renderQue = this.render.bind(this)
    this.resizeQue = this.resize.bind(this)
    stage.on("stage:scroll", this.renderQue)
    stage.on("stage:resize", this.resizeQue)
    
    this.resize()
    this.addEvents()
  }


  resize(e) {

    if ( !e ) {
      e = stage
    }

    this.sections.each( (index, el) => {
      var sectionname = $(el).data('to')
      var section = $(`[data-section="${sectionname}"]`)
      section.data('position', section.length ? section.offset().top : 0)
    })

    this.render(e)
  }


  render(e) {

    if(e.scrolltop > 90){
      TweenMax.set(this.nav, { y:-45, force3D: true})
    }
    else {
      TweenMax.set(this.nav, { y:-e.scrolltop/2, force3D: true})
    }
    //console.log(e.scrolltop)
    this.nav.toggleClass('is-sticky', e.scrolltop > 90)
    this.nav.toggleClass('is-up', e.scrollDirection >= 0 && e.scrolltop > 90)
  }


  addEvents() {

    $('[data-to]').on('click', (e) => {
      e.preventDefault()
      var el = $(e.currentTarget)
      var sectionname = el.data('to')
      var section = $(`[data-section="${sectionname}"]`)

      // Remove mobile overlay if activated
      this.body.removeClass('has-nav-overlay')

      $.scrollTo({top:section.data('position'), left: 0, interrupt: true}, 1000)
      // Show sticky nav after scroll to anchor
      this.nav.delay(1050).queue(function(next) {
        $(this).addClass('is-up')
        next()
      })
    })

    $('#nav-toggle, #nav-overlay-bg').on('click', (e) => {
      e.preventDefault()
      this.body.toggleClass('has-nav-overlay')
    })

  }


  removeEvents() {
    $('[data-to]').off('click')
    $('#nav-toggle, #nav-overlay-bg, .has-nav-overlay [data-to]').off('click')
    stage.removeListener("stage:scroll", this.renderQue)
    stage.removeListener("stage:resize", this.resizeQue)
  }


  destroy() {
    this.removeEvents()
    this.body.removeClass('has-nav-overlay')
  }


}

module.exports = Navigation
